import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_CASE_MIX_GROUP_FAILURE,
  GET_CASE_MIX_GROUP_REQUEST,
  GET_CASE_MIX_GROUP_LOADING,
  GET_CASE_MIX_GROUP_SUCCESS,
} = therapyPlanningAction;

function* getCaseMixGroup(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_CASE_MIX_GROUP_LOADING });
    const response = yield call(therapyPlanningService.getCaseMixGroup, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_CASE_MIX_GROUP_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_CASE_MIX_GROUP_FAILURE, payload: error });
  }
}

function* getCaseMixGroupSaga() {
  // takeLatest: rapid ARD changes re-dispatch this request; only the newest response may land.
  yield takeLatest(GET_CASE_MIX_GROUP_REQUEST, getCaseMixGroup);
}

export default getCaseMixGroupSaga;
